module.exports = __webpack_public_path__ + "media/images/favicon-3e3c18f836ad6bf1dab1c791d68e84ed.ico";